import { HttpService, getError } from './http.service';

const ActivityService = {
  ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  ACTIVITY_TYPES: {
    ARTICLE: {
      VIEWED: {
        endpoint: 'api/activity/article/viewed'
      }
    },
    AUTH: {
      STUDENT_LOGIN: {
        endpoint: 'api/activity/auth/student-login'
      }
    }
  },

  logActivity(activityType, requestData) {
    return HttpService.httpPost(`${this.ADMIN_API_HOST}/${activityType.endpoint}`, requestData)
        .catch(e => {
          throw getError(e);
        });
  },
};

export default ActivityService;
